import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { FilledButton } from '../../core/Button/variants/FilledButton';
import { slideToRight, delayedAnimation } from './shared';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 268px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    max-width: 400px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    min-height: 356px;
    max-width: 100%;
  }
`;

const BaseImage = styled.img`
  position: absolute;
  top: 0;
  right: 100%;
  margin-right: 89px;

  width: 224px;
  height: 242px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin-right: 138px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    width: 310px;
    height: 337px;

    margin-right: 157px;
  }
`;

const RepresentativeImage = styled.img`
  position: absolute;
  top: 156px;
  right: 100%;
  margin-right: -10px;

  width: 205px;
  height: 111px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    top: 139px;
    width: 237px;
    height: 128px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 200px;
    width: 287px;
    height: 156px;
  }
`;

const JoinButton = styled(FilledButton)<IThemeProps>`
  position: absolute;
  top: 228px;
  right: 100%;
  margin-right: 236px;
  cursor: default;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin-right: 285px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 316px;
    margin-right: 392px;
  }

  padding: 12px 24px;
  background-color: #e2b100;
  height: min-content;
  color: #fff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
  font-size: 12px;
  line-height: 16px;

  :hover {
    text-decoration: none;
    background-color: #e2b100;
    color: #fff;
  }
`;

const RequestMeetingButton = styled(FilledButton)<IThemeProps>`
  position: absolute;
  top: 108px;
  right: 100%;
  margin-right: 0;
  cursor: default;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    top: 91px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 144px;
  }

  padding: 12px 32px;
  border-radius: 24px;
  height: min-content;
  color: #fff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
  font-size: 12px;
  line-height: 16px;

  :hover {
    text-decoration: none;
  }
`;

export const Sponsors = () => {
  return (
    <Wrapper>
      <BaseImage css={slideToRight} src="/images/landing/eventExample/sponsor-card.png" alt="sponsor" />
      <RepresentativeImage
        css={[slideToRight, delayedAnimation(0.7)]}
        src="/images/landing/eventExample/sponsor-representative.png"
        alt="sponsor representative"
      />
      <RequestMeetingButton css={[slideToRight, delayedAnimation(1.1)]}>request a meeting</RequestMeetingButton>
      <JoinButton css={[slideToRight, delayedAnimation(1.5)]}>join room</JoinButton>
    </Wrapper>
  );
};
